import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_MD } from '_assets/css/breakpoints';

export const loaderContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const stopContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  color: var(${DesignToken.ContentBasicPrimary});
  overflow-y: hidden;
  gap: var(${SpacingToken.Spacing3});

  ${MEDIA_MIN_MD} {
    justify-content: center;
    padding-top: 0;
  }
`;

export const errorContainer = css`
  max-width: 380px;
`;

export const logo = css`
  display: flex;
  position: absolute;
  left: 16px;
  top: 16px;

  ${MEDIA_MIN_MD} {
    left: 32px;
    top: 32px;
  }
`;

export const rows = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
`;
